import { useContext, useEffect, useState } from 'react'

import Axios from 'axios';
import { Col, Form, Row, Table } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

import DashboardContext from '../../../Context';
import Loader from '../../layout/Loader';
import Pagination from './Pagination';
import SearchFrom from '../SearchFrom';
import Tabelrowbody from '../Tabelrowbody';

import '../tabel.css'
import ExcelExport from '../ExcelExport';

export default function TabelProps({ urldata, arryactions, userId, accordionTable = false }) {

    const { sideBardata, authentication, urldashboard, accessPage, handelloding, idview, idCustomer } = useContext(DashboardContext);

    const { location } = useHistory()

    const [dataFech, setDataFech] = useState({})

    const [startpage, setStartpage] = useState(JSON.parse(sessionStorage.getItem('startpageProps')) || 1)

    const [pageSize, setPageSize] = useState(JSON.parse(sessionStorage.getItem('pageSizeProps')) || 10)

    const [serch, setSerch] = useState(JSON.parse(sessionStorage.getItem('serchProps')) || '')
    const [deleteitem, setDeleteitem] = useState(false)

    const [loader, setLoader] = useState(true)


    const [inputvalue, setInputvalue] = useState("")


    const datafeching = async (startpage, pageSize, serch) => {

        const formdata = {
            "page": parseInt(startpage),
            "pageSize": parseInt(pageSize),
            "search": serch,
        }


        try {
            const res = await Axios.post(`${urldashboard}${urldata}/get/${JSON.parse(sessionStorage.getItem('workerId')) ? JSON.parse(sessionStorage.getItem('workerId')) : idCustomer ? idCustomer : idview}`, JSON.stringify(formdata), {
                headers: {
                    "Authorization": authentication,
                    "Content-Type": "application/json"
                }
            })

            const data = await res.data
            setDataFech(data)
            setLoader(false)
            handelloding(false)
        } catch (error) {
            //console.log(error.response);
        }
    }



    useEffect(() => {
        datafeching(startpage, pageSize, serch)
        return () => {

        }
    }, [startpage, pageSize, serch, location.pathname, deleteitem])


    //logic serch start
    const handelserchinput = e => {
        if (e.target.value) {
            setInputvalue(e.target.value)
        }
        else {
            setInputvalue("")
            sessionStorage.setItem('serchProps', JSON.stringify(''))
            setSerch('')
            setLoader(true)
            sessionStorage.setItem('startpageProps', JSON.stringify(1))
            sessionStorage.setItem('PaginationProps', JSON.stringify([]))

            setStartpage(1)
        }
    }

    const handelserch = (e) => {
        e.preventDefault()
        sessionStorage.setItem('serchProps', JSON.stringify(inputvalue))
        setSerch(inputvalue)
        setLoader(true)
        sessionStorage.setItem('startpageProps', JSON.stringify(1))
        sessionStorage.setItem('PaginationProps', JSON.stringify([]))

        setStartpage(1)

    }
    //logic serch end


    const handeldeleteitem = () => setDeleteitem(!deleteitem)


    //logic Pagination start
    const handelpagenumber = (number) => {
        sessionStorage.setItem('startpageProps', JSON.stringify(number))
        setStartpage(number)
    }

    const handelprevpage = () => {
        if (parseInt(dataFech.page) === 1) {

        }
        else {
            sessionStorage.setItem('startpageProps', JSON.stringify(startpage - 1))
            setStartpage(startpage - 1)
        }
    }

    const handelNextpage = () => {
        if (dataFech.page === dataFech.totalPage) {

        }
        else {
            sessionStorage.setItem('startpageProps', JSON.stringify(startpage + 1))
            setStartpage(startpage + 1)
        }
    }
    //logic Pagination end

    const arryrowpage = [10, 20, 50, 100, 500]
    const handelrowPage = e => {
        setPageSize(parseInt(e.target.value))
        sessionStorage.setItem('pageSizeProps', JSON.stringify(parseInt(e.target.value)))
        sessionStorage.setItem('startpageProps', JSON.stringify(1))
        sessionStorage.setItem('PaginationProps', JSON.stringify([]))

        setStartpage(1)
        setLoader(true)
    }


    return (
        <>
            {
                sideBardata.length > 0 ?
                    <>

                        < Row className='mb-3 mt-3' >
                            <SearchFrom
                                handelserchinput={handelserchinput}
                                handelserch={handelserch} />

                            <Col md={6} sm={6} xs={12}  >
                                <div className='d-flex justify-content-end mt-sm-0 mt-lg-0 mt-3' >
                                    <button type="button"
                                        className="btn btn-primary btn-icon-text btn-sm">
                                        پرینت {" "}
                                        <i className="mdi mdi-printer btn-icon-append"></i>
                                    </button>
                                    {
                                        dataFech.hasOwnProperty("data") ?
                                            <ExcelExport data={dataFech.data}
                                                headers={dataFech.headers.map(item => item.label)}
                                                filename={location.pathname.slice(1, location.pathname.length)} />
                                            : null
                                    }
                                </div>

                            </Col>
                        </ Row>
                        {
                            !loader ?

                                dataFech.data.length > 0 ?

                                    <>
                                        <Table hover className='tabeldata' >
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    {dataFech.headers.length > 10 ?
                                                        dataFech.headers.slice(0, 10).map(item =>
                                                        (item.name === 'Id' ? <th key={item.name}>ردیف</th> : <th key={item.name} >
                                                            {item.label}
                                                        </th>))
                                                        : dataFech.headers.map(item =>
                                                        (item.name === 'Id' ? <th key={item.name}>ردیف</th> : <th key={item.name} >
                                                            {item.label}
                                                        </th>))
                                                    }
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {dataFech.data.map((item, index) => (
                                                    <Tabelrowbody
                                                        arryheder={dataFech.headers.length > 10 ? dataFech.headers.slice(10, dataFech.headers.length) : []}
                                                        page={startpage}
                                                        key={item.id}
                                                        item={item}
                                                        number={index}
                                                        urldata={urldata}
                                                        handeldeleteitem={handeldeleteitem}
                                                        arryactions={arryactions}
                                                        accordionTable={accordionTable}
                                                    />
                                                ))
                                                }
                                            </tbody>
                                        </Table>

                                        <Row className='mt-3 mb-5' >
                                            <Col md={5} sm={6} xs={12}
                                                className='d-flex align-items-baseline' >

                                                <Pagination
                                                    totalPage={dataFech.totalPage}
                                                    page={dataFech.page}
                                                    handelprevpage={handelprevpage}
                                                    handelNextpage={handelNextpage}
                                                    handelpagenumber={handelpagenumber}
                                                />

                                            </Col>
                                            <Col md={4} sm={3} xs={6}
                                                className='d-flex align-items-end d-sm-block mt-sm-2' >
                                                <div className='d-flex ml-auto mr-sm-auto ' >
                                                    <p>مجموع کل : </p>
                                                    <span className='mr-2'>{" "}
                                                        {dataFech.totalRecord}{" "}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col md={3} sm={3} xs={6}
                                                className='mt-sm-0 mt-3 mt-md-0'  >
                                                <div className='rowminger' >
                                                    <p className='text-nowrap' >تعداد ردیف :</p>
                                                    <Form.Control size="sm" as="select"
                                                        onChange={handelrowPage}  >
                                                        {
                                                            arryrowpage.map(item =>
                                                            (<option key={item}
                                                                selected={item === pageSize ?
                                                                    true :
                                                                    false}
                                                                value={item} >{item}</option>))
                                                        }

                                                    </Form.Control>
                                                </div>
                                            </Col>
                                        </Row>
                                    </>

                                    : " چیزی یافت نشد :("


                                : <Loader />
                        }
                    </>
                    : <Loader />

            }
        </>)
}
